import { render, staticRenderFns } from "./editPrintReceipt.vue?vue&type=template&id=54757387&scoped=true"
import script from "./editPrintReceipt.vue?vue&type=script&lang=js"
export * from "./editPrintReceipt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54757387",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\XM\\QD\\yangzhou\\merchant-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('54757387')) {
      api.createRecord('54757387', component.options)
    } else {
      api.reload('54757387', component.options)
    }
    module.hot.accept("./editPrintReceipt.vue?vue&type=template&id=54757387&scoped=true", function () {
      api.rerender('54757387', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/systemSetting/printing/printReceipt/editPrintReceipt.vue"
export default component.exports